import axios from 'axios';
import { PARAMS } from '../../const';
import {
  API_CONTENT_BY_ACTIVITY_ID,
  API_ACTIVITIES_BY_PARENT_ID,
  API_SECTION_ACTIVITIES_BY_PARENT_ID
} from '../../services/api/apiConst';
import { getLogger } from '../logger';

const debug = getLogger('services:api:activitiesApi');

//----------------------------------------------------------------------------------------------------------------------
export let getContentByActivityId = (classroomId, activityId) => {
  if (classroomId && activityId) {
    let url = API_CONTENT_BY_ACTIVITY_ID.replace(PARAMS.CLASSROOM, classroomId).replace(PARAMS.ACTIVITY, activityId);
    return axios.get(url);
  }
  debug.error('[getContentByActivityId] required params not found ');
};

//----------------------------------------------------------------------------------------------------------------------
export let getContentAndChildrenByActivityId = (sectionId, activityId) => {
  if (sectionId && activityId) {
    let url = API_SECTION_ACTIVITIES_BY_PARENT_ID.replace(PARAMS.SECTION, sectionId).replace(
      PARAMS.ACTIVITY,
      activityId
    );
    return axios.get(url);
  }
  debug.error('[getContentAndChildrenByActivityId] required params not found ');
};

//----------------------------------------------------------------------------------------------------------------------
export let postActivityTree = (classroomId, activityId, payload) => {
  if (classroomId && activityId) {
    let url = API_ACTIVITIES_BY_PARENT_ID.replace(PARAMS.CLASSROOM, classroomId).replace(PARAMS.ACTIVITY, activityId);
    return axios.post(url, payload);
  }
  debug.error('[postActivityTree] required params not found ');
};
